import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, map, take, filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DriverDeviationAccessGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> | boolean {
    if (!this.authService.getActiveAccount()) {
      this.router.navigateByUrl('restricted');
      return false;
    }

    // Wait for user groups to be loaded before checking access
    return this.authService.userGroupsReady$.pipe(
      filter(loaded => loaded === true),
      take(1),
      map(() => {
        if (!this.authService.hasDriverDeviationAccess()) {
          this.router.navigateByUrl('restricted');
          return false;
        }
        return true;
      })
    );
  }
}
